[
  {
    "name": "independentLiquidGravity",
    "description": "Liquid gravity is a constant",
    "versions": ["1.8", "1.9", "1.10", "1.11", "1.12"]
  },
  {
    "name": "proportionalLiquidGravity",
    "description": "Liquid gravity is a proportion of normal gravity",
    "versions": ["1.13", "1.14", "1.15", "1.16", "1.17", "1.18", "1.19", "1.20"]
  },
  {
    "name": "velocityBlocksOnCollision",
    "description": "Velocity changes are caused by blocks are triggered by collision with the block",
    "versions": ["1.8", "1.9", "1.10", "1.11", "1.12", "1.13", "1.14"]
  },
  {
    "name": "velocityBlocksOnTop",
    "description": "Velocity changes are caused by the block the player is standing on",
    "versions": ["1.15", "1.17", "1.18"]
  },
  {
    "name": "climbUsingJump",
    "description": "Entity can climb ladders and vines by pressing jump",
    "versions": ["1.14", "1.15", "1.17", "1.18"]
  }
]
